<script>
import modal from '@/components/view/modal'
import videoPlayer from '@/components/view/video-player'
export default {
  components: {
    'gp-modal': modal,
    'video-player': videoPlayer
  },
  computed: {
    videoList () {
      const keys = Object.keys(this.docs.video)
        .sort((a, b) => a > b ? -1 : 1)
      const videoList = []
      keys.forEach(key => {
        videoList.push({
          ...this.docs.video[key],
          id: key
        })
      })
      return videoList
    },
    videoId () {
      return this.$route.hash.replace('#', '')
    }
  }
}
</script>

<template>
  <div class="gp-movie">
    <div class="page-background"></div>
    <div class="container">
      <header>
        <h1 class="page-title">MOVIE</h1>
      </header>
      <div>
        <ul>
          <li
            class="video is-small"
            v-for="video in videoList"
            :key="video.id"
          >
            <router-link :to="{name: 'movie', hash: '#' + video.id}">
              <figure>
                <img :src="video.image">
              </figure>
              <div class="title has-text-weight-bold has-text-align-center is-size-4 is-size-5-mobile">{{ video.title }}</div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition name="slide-up">
      <gp-modal v-if="videoId" :route="{name: 'movie'}">
        <video-player :videoId="videoId" :route="{name: 'movie'}"/>
      </gp-modal>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.gp-movie {
  .container {
    @include is-not-mobile {
      max-width: 60rem;
      padding: 0 3rem;
      margin: auto;
    }
  }
  ul {
    padding: 0 1.5rem;
    @include is-not-mobile {
      display: flex;
      flex-wrap: wrap;
    }
    li.video {
      @include is-mobile {
        margin-bottom: 1.75rem;
      }
      @include is-not-mobile {
        margin-bottom: 3rem;
        width: calc(100% / 2 - 1.25rem);
        &:not(:nth-child(2n)) {
          margin-right: 2.5rem;
        }
      }
      .title {
        margin-top: .25rem;
      }
      figure {
        border: solid 4px $black;
        background-color: $black;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/movie.vue